<template>
  <div class="job-seniority-area-selector">
    <h4
      v-if="name && !settings.noHeader"
      :class="{ 'text-danger': invalidFeedback }"
    >
      <b>{{name}}{{required ? '*' : ''}}</b>
    </h4>
    <p
      v-if="description && !settings.noHeader"
      :class="{ 'text-danger': invalidFeedback, 'text-muted': !invalidFeedback }"
    >
      {{description}}
    </p>
    <b-form-group :label="settings.noHeader ? name : (settings.noTitle ? null : 'Seniority')">
      <multiselect
        :value="value"
        @input="$emit('input', $event)"
        :options="options && options.length ? options : defaultOptions"
        :multiple="multiple"
        :group-select="false"
        placeholder="Select a seniority level"
        class="multiselect-rlnx"
      >
        <template v-slot:noResult>seniority level not found, try something similar</template>
      </multiselect>
    </b-form-group>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'JobSenioritySelector',
  components: {
    Multiselect
  },
  props: {
    name: {
      type: String,
    },
    description: {
      type: String,
    },
    value: {
      default: () => null,
    },
    options: {
      type: Array,
      default: () => null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
    invalidFeedback: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    fatalErr: null,
    err: null,
    defaultOptions: [
      'Entry-level',
      'Mid-level',
      'Senior-level',
    ],
    department: null,
  }),
};
</script>

<style lang="scss">
.job-seniority-area-selector {
  .multiselect-rlnx {
    .multiselect__tags {
      height: auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/profile/JobSenioritySelector.vue